export default "__VITE_ASSET__beaa10d5__"